import React, { useRef, useEffect } from 'react'
import PropTypes from 'prop-types'

import IndexVideo from '../../images/oil.mp4';
import { VideoContainer, Video, PageWrapper, Button, ButtonsWrapper } from './styles';
import SEO from '~/components/seo'


const IndexPage = props => {
  const videoEl = useRef(null);

  const {
    data: {
      pageData: {
        frontmatter: { seo_title, seo_description, btnOneText, btnOneLink, btnTwoText, btnTwoLink },
      },
    },
  } = props

  useEffect(() => {
    videoEl.current.play();
  },[])

  const pastLaunchTime = Date.now() >= new Date("2020-07-02T03:00:00.000+08:00");

  return (
    <>
    <SEO title={seo_title} description={seo_description} />
    <PageWrapper>
      <VideoContainer>
        <Video autoplay loop muted ref={videoEl} playsInline>
          <source src={IndexVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </Video>
        {
          pastLaunchTime && (
            <ButtonsWrapper>
              <Button to={btnOneLink}>
                {btnOneText}
              </Button>
            </ButtonsWrapper>
          )
        }
      </VideoContainer>
    </PageWrapper>
    </>
  )
}

IndexPage.propTypes = {

}

export const query = graphql`
  query($slug: String) {
    pageData: markdownRemark(fields: { slug: { eq: $slug } }) {
      frontmatter {
        seo_title
        seo_description
        title
        text
        btnOneText
        btnOneLink
        btnTwoText
        btnTwoLink
      }
    }
  }
`

export default IndexPage
